import { render, staticRenderFns } from "./TransferLeadsModal.vue?vue&type=template&id=5421dbc4&scoped=true&"
import script from "./TransferLeadsModal.vue?vue&type=script&lang=js&"
export * from "./TransferLeadsModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferLeadsModal.vue?vue&type=style&index=0&id=5421dbc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421dbc4",
  null
  
)

export default component.exports